<template>
    <div class="pageBox">
        <div class="option">
            <el-button @click="add()">上传代理品牌</el-button>
        </div>
        <div class="table" ref="table">
            <el-table element-loading-text="数据加载中..." v-loading="loading" stripe :height='height' :data="list" border>
                <el-table-column label="排序" prop="sort" align="center" width="100">
                </el-table-column>
                <el-table-column label="品牌网址" prop="redirectUrl" align="center">
                </el-table-column>
                <el-table-column label="品牌LOGO" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.logoUrl"
                            :preview-src-list="[scope.row.logoUrl]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                        <el-button @click="remove(scope.row)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
                :page-sizes="[20, 40, 60, 80, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="代理品牌" :visible.sync="dialogShow" width="30%">
            <el-form label-width="90px">
                <el-form-item label="品牌LOGO">
                    <el-upload v-if="fileListLoaded && dialogShow" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-exceed="handleExceed" :on-remove="handleRemove"
                        :on-change="handleFileChange" :limit="1" :multiple="false" :file-list="fileList" action=""
                        :auto-upload="false">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="品牌网址">
                    <el-input v-model="form.redirectUrl" placeholder="请输入品牌网址"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">关闭</el-button>
                <el-button type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import { fileRemove, fileUpload, agentBrandAdd, agentBrandEdit, agentBrandPage, agentBrandDetail, agentBrandRemove } from '../api.js';
export default {
    data() {
        return {
            list: [],
            total: 0,
            size: 20,
            current: 1,
            height: 0,
            loading: true,
            dialogShow: false,
            dialogImageUrl: '',
            dialogVisible: false,

            form: {
                logoUrl: '',
                sort: 0,
                redirectUrl: '',
            },
            fileList: [],
            fileListLoaded: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.getList()
    },
    methods: {
        handleFileChange(file, fileList) {
            console.log(file);
            const formData = new FormData();
            formData.append('file', file.raw);
            fileUpload(formData).then(res => {
                if (res.code === 0) {
                    this.form.logoUrl = res.data
                }
            })
        },
        handleRemove(file, fileList) {
            this.form.logoUrl = ''
            this.fileList = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleExceed() {
            this.$message.error('请删除后重新上传')
        },
        confirm() {
            if (this.form.id) {
                agentBrandEdit(this.form).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '编辑成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            } else {
                agentBrandAdd(this.form).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '新增成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            }
        },
        getList() {
            this.loading = true
            agentBrandPage({ current: this.current, size: this.size }).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.total = res.data.total
                    this.loading = false
                }
            })
        },
        add() {
            this.form = {
                logoUrl: '',
                sort: 0,
                redirectUrl: ''
            }
            this.fileList = []
            this.fileListLoaded = true;
            this.dialogShow = true
        },
        edit(row) {
            agentBrandDetail(row.id).then(res => {
                if (res.code === 0) {
                    this.form = {
                        id: res.data.id,
                        logoUrl: res.data.logoUrl || '',
                        sort: res.data.sort || 0,
                        redirectUrl: res.data.redirectUrl,
                    }
                    this.fileList = res.data.logoUrl ? [{ name: res.data.logoUrl.split('/').pop(), url: res.data.logoUrl }] : []
                    this.fileListLoaded = true;
                    this.dialogShow = true
                }
            })
        },
        remove(row) {
            this.$confirm(`确定要删除该代理品牌吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                agentBrandRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        handleSizeChange(val) {
            this.current = 1
            this.size = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.current = val
            this.getList()
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
    }
}
</script>
<style scoped lang="less">
.pageBox {
    width: 100%;
    height: 100%;
    padding: 20px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;
    }

    .table {
        flex: 1;
    }

    .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>